import { Component, OnInit } from '@angular/core';
import { AngularFireAuth } from 'angularfire2/auth';
import { AngularFireDatabase, AngularFireDatabaseModule} from 'angularfire2/database';
import swal from 'sweetalert';
import {Router} from '@angular/router';
@Component({
  selector: 'app-login',
  templateUrl: './login.component.html',
  styleUrls: ['./login.component.css']
})
export class LoginComponent implements OnInit {

  username;
  password;
  connect_check_login;
  constructor( 
    private router: Router,
    public db:AngularFireDatabase ,
    private fire: AngularFireAuth) { }

  ngOnInit() {
  }
  signInUser(){
    if(this.username != null && this.password != null ){
      var username_low= this.username.toLowerCase()
      this.fire.auth.signInWithEmailAndPassword(username_low+'@domian.xta',this.password)
      .then(data=>{
        console.log('test');
        this.check_cat()
      })
      .then(data =>{
        // this.check_cat()
       console.log('got some data',this.fire.auth.currentUser);
       this.alert('ยินดีต้อนรับเข้าสู่ระบบ')
      })
      .catch(error =>{
        this.alert('กรุณาป้อน Username และ Password อีกครั้ง')
        console.log('got an error',error);
      })
  
      console.log('Would register user with',username_low,this.password);
    }

  }
  alert_confirm(){

    swal({
      title: "คุณต้องการเพิ่มประเภทขยะรีไซเคิล?",
      text: "ใช่หรือไม่",
      icon: "warning",
      buttons: true,
      dangerMode: true,
    })
    .then((willDelete) => {
      if (willDelete) {
        swal("การเพิ่มข้อมูลประเภทขยะรีไซเคิลสำเร็จ", {
          icon: "success",
        });
        console.log('save')   
      } else {
        swal("การเเพิ่มข้อมูลประเภทขยะรีไซเคิลไม่สำเร็จ!");
      }
    });
    //  alert('กรุณาป้อนข้อมูล')
  }
  alert(message){
    swal("แจ้งเตือน!", message);
  }
  check_cat(){
    console.log('check_cat')
    this.connect_check_login = this.db.database.ref('user').orderByChild('username').equalTo((this.username+'@domian.xta').toLowerCase());
    this.connect_check_login.on('child_added',snap =>{

      this.getstorage(
      snap.val().uid,
      snap.val().username,
      snap.val().tel,
      snap.val().password);
      
      console.log(snap.val().photoURL);

    })
  }
  getstorage(uid,username,tel,password){
    localStorage.setItem('uid', uid);
    localStorage.setItem('username', username);
    localStorage.setItem('tel', tel);
    localStorage.setItem('password', password);
    this.alert('ท่านสามารถใช้ สูตรได้เลยในขณะนี้')
    this.router.navigateByUrl('/');
  }
}
